// Limpieza de lo que el navegador guarda localmente tras vaciar los datos de
// la cuenta o eliminarla (pages/Account.js, zona peligrosa).
import secureStorage from '../services/secureStorage';

// Mismas claves que escribe components/OTPManager.js en secureStorage.
const OTP_CACHE_KEYS = [
  'otp_entries_cache',
  'otp_entries_cache_timestamp',
  'otp_entries_cache_version',
  'otp_entries_item_id',
  'otp_entries_item_updated_at',
  'otp_entries_last_global_update',
];

// Tras vaciar los datos: fuera las cachés de ítems y de códigos 2FA, que
// seguirían mostrando lo borrado. La sesión, la configuración y los
// dispositivos de confianza se quedan.
export function clearVaultCaches() {
  if (secureStorage.isReady()) {
    OTP_CACHE_KEYS.forEach((key) => secureStorage.removeItem(key));
    // Cachés antiguas del vault (secureStorage también las purga al iniciar).
    secureStorage.getAllKeys()
      .filter((key) => key.startsWith('credentials_'))
      .forEach((key) => secureStorage.removeItem(key));
  }
  localStorage.removeItem('otpEntries');
}

// Tras eliminar la cuenta: todo el almacenamiento local, incluidas las bases
// IndexedDB de secureStorage. Se borran en bloque, no solo las de esta
// cuenta: la página va a recargarse en /login y no debe quedar nada.
export async function clearAllLocalData() {
  try {
    if (typeof indexedDB?.databases === 'function') {
      const dbs = await indexedDB.databases();
      dbs.forEach((db) => { if (db?.name) indexedDB.deleteDatabase(db.name); });
    }
  } catch { /* sin IndexedDB o sin permiso: queda localStorage */ }
  try { localStorage.clear(); } catch { /* almacenamiento bloqueado */ }
  try { sessionStorage.clear(); } catch { /* idem */ }
}
